module.exports = __webpack_public_path__ + "img/logo.99f8fd5c.svg";